
import React from 'react';

export const UserIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    group
  </span>
);